<template>
    <div v-if="site">
        <v-menu
            close-on-click
            offset-x
            nudge-left="-10"
            nudge-top="10"
            v-model="createOpen"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            :color="background"
                            small
                            fab
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon :color="color">mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("unit.menu.create") }}</span>
                </v-tooltip>
            </template>
            <c-column-header label="Neues Ereignis anlegen" class="primary" title-border>
                <template v-slot:pre>
                    <div style="min-width: 18px"></div>
                </template>
            </c-column-header>
            <v-list >
                <template
                    v-for="(item, index) in incidenttypes"
                >
                    <v-list-item link :key="index" @click="onCreate(item, null)">
                        <v-list-item-title>
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                    <!--
                    <v-list-group
                        :key="index"
                        v-if="item.id===1"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            v-for="(type, index) in assessmenttypes"
                            :key="index"
                            @click="onCreate(item, type)"
                        >
                            <v-list-item-title class="ml-4 v-flex">
                                - {{ type.name }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    -->
                </template>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import Inc from "@/modules/inc/service/Inc";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "IncCreateButton",
    components: {
        CColumnHeader,
    },
    props: {
        category: {
            required: false,
            default: function () {
                return null;
            }
        },
        background: {
            required: false,
            type    : String,
            default: function () {
                return 'white'
            }
        },
        color: {
            required: false,
            type    : String,
            default: function () {
                return 'primary'
            }
        },
        site: {
            required: false,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        createOpen : false,
    }),

    watch: {
        createOpen () {
            this.$emit("opend", this.createOpen)
        },

        showError () {
            console.log("showError: " + this.showError)
        }
    },

    computed: {
        incidenttypes () {
            if (this.category !== null) {
                return this.$store.getters.incidenttypes.filter(type => type.category === this.category);
            }

            return this.$store.getters.incidenttypes;
        },

        assessmenttypes () {
            return this.$store.getters.inc.assessmenttypes;
        }

    },

    methods: {
        onCreate (item, type) {
            Inc.create (this, [this.site], item.id, {
                    subtype: type === null ? null : type.id,
                    prev   : null,
                    date   : null
                }, this.$t("inc.loading.create"),
                (data) => {
                    this.createOpen = false;
                    if (data.hint) {
                        Core.message.popup(this, data.hint);
                    }

                    Inc.goto(this, data.data.id);
                },
                (data) => {
                    Core.message.popup(this, data);
                }
            );
        },
    }
}
</script>
<style scoped>

</style>